export default {
  confirm: 'Bestätigen',
  title: 'Berechtigte Angebote',
};
